export { DeteriorationModelConfigurationTab } from './DeteriorationModelConfigurationTab';
